module.exports = __webpack_public_path__ + "img/NotifyWarning.25a55cd3.svg";